import {Icon, view} from '@sail/ui';
import type {IconAsset, SvgType} from '@sail/icons/types';
import {View, createView} from '@sail/engine';

const AvatarSvg = createView((props: View.IntrinsicElement<'svg'>) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      style={{
        // Needed to override a default CSS `fill: rgb(0, 0, 0)` styling in Sail
        fill: 'none',
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="14" fill="white" />
      <path
        d="M0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14Z"
        fill="white"
      />
      <path
        d="M0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14Z"
        stroke="#E0D9FB"
      />
      <path
        d="M17.4725 8.62411C17.5435 8.59893 17.5994 8.54302 17.6246 8.47196L18.2649 6.66504C18.3042 6.55404 18.4023 6.49854 18.5005 6.49854C18.5986 6.49853 18.6968 6.55403 18.7361 6.66504L19.3764 8.47196C19.4016 8.54302 19.4575 8.59893 19.5285 8.62411L21.3355 9.26436C21.4465 9.30369 21.502 9.40184 21.502 9.5C21.502 9.59816 21.4465 9.69631 21.3355 9.73565L19.5285 10.3759C19.4575 10.4011 19.4016 10.457 19.3764 10.528L18.7361 12.335C18.6968 12.446 18.5986 12.5015 18.5005 12.5015C18.4023 12.5015 18.3042 12.446 18.2649 12.335L17.6246 10.528C17.5994 10.457 17.5435 10.4011 17.4725 10.3759L15.6655 9.73565C15.5545 9.69632 15.499 9.59816 15.499 9.5C15.499 9.40184 15.5545 9.30369 15.6655 9.26436L17.4725 8.62411Z"
        fill="#675DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0005 11.4912L12.4407 13.0709C12.2141 13.7105 11.711 14.2136 11.0714 14.4402L9.49169 15L11.0714 15.5598C11.711 15.7864 12.2141 16.2895 12.4407 16.9291L13.0005 18.5088L13.5602 16.9291C13.7869 16.2895 14.29 15.7864 14.9296 15.5598L16.5093 15L14.9296 14.4402C14.29 14.2136 13.7869 13.7105 13.5602 13.0709L13.0005 11.4912ZM13.7074 8.99511C13.5894 8.6621 13.295 8.49559 13.0005 8.4956C12.706 8.4956 12.4116 8.6621 12.2936 8.99511L11.0269 12.5699C10.9513 12.7831 10.7836 12.9508 10.5704 13.0264L6.9956 14.2931C6.6626 14.4111 6.49609 14.7055 6.49609 15C6.49609 15.2945 6.6626 15.5889 6.9956 15.7069L10.5704 16.9736C10.7836 17.0492 10.9513 17.2169 11.0269 17.4301L12.2936 21.0049C12.4116 21.3379 12.706 21.5044 13.0005 21.5044C13.295 21.5044 13.5894 21.3379 13.7074 21.0049L14.9741 17.4301C15.0497 17.2169 15.2174 17.0492 15.4306 16.9736L19.0054 15.7069C19.3384 15.5889 19.5049 15.2945 19.5049 15C19.5049 14.7055 19.3384 14.4111 19.0054 14.2931L15.4306 13.0264C15.2174 12.9508 15.0497 12.7831 14.9741 12.5699L13.7074 8.99511Z"
        fill="#675DFF"
      />
    </svg>
  );
});

const avatarIcon: IconAsset = {
  category: 'icon',
  colorable: false,
  name: 'stripe_ai_avatar_icon',
  svg: AvatarSvg as SvgType,
};

type Props = {
  size?: string;
  borderRadius?: string;
};

export const SupportAIAvatar = ({
  size = '28px',
  borderRadius = '50%',
}: Props) => {
  return (
    <view.div data-testid="support-ai-avatar" role="avatar">
      <Icon
        icon={avatarIcon}
        css={{
          width: size,
          height: size,
          borderRadius,
        }}
      />
    </view.div>
  );
};
